/**
 * web-studio-sites D14 — the booking plug-in: the website pieces and pages
 * cards 1 to 3 built (web-client-app, web-sign-in-checkout, web-account-pages)
 * and the website's reads and sign-in under `/api/site`. Its switch is the
 * studio's website (`web-site`); it is not a paid add-on. Card 4's new pieces
 * join this declaration as they are built. session-own-link D6: its admin
 * route is a service's "On your website" setting.
 */
import { definePlugin, type PluginRoute } from './define.js';

/** web-sign-in-checkout D5: the catalog twice, for the guest and, under `/client`, for the signed-in client. */
const catalog = (prefix: '' | '/client'): PluginRoute[] =>
  [
    '/services',
    '/services/:id',
    '/events',
    '/events/:id',
    '/series/:id',
    '/services/:id/available-dates',
    '/services/:id/availability',
    '/next-openings',
  ].map((path) => ({ method: 'GET', url: `/api/site${prefix}${path}` }));

export const bookingPlugin = definePlugin({
  id: 'booking',
  name: 'Booking',
  description:
    "The studio's website booking: its services, events and open times, Telegram sign-in, the checkout, and the client's bookings, profile and messages.",
  paidAddOn: false,
  feature: 'web-site',
  pieces: [
    'account',
    'booked',
    'booking-column',
    'booking-page',
    'bookings-list',
    'checkout',
    'coming-up',
    'complete-step',
    'event-page',
    'events-grid',
    'events-row',
    'form-request',
    'forms-step',
    'guide',
    'hero',
    'hold-clock',
    'hold-recovery',
    'home-welcome',
    'message-banner',
    'message-studio',
    'messages-panel',
    'next-session',
    'not-found',
    'offerings',
    'open-times',
    'payment-step',
    'photo-gallery',
    'profile',
    'registration-step',
    'request-sent',
    'review-step',
    'service-page',
    'services',
    'sign-in-step',
    'story',
    'studio-footer',
    'studio-header',
    'waiting-on-you',
  ],
  pages: [
    'home',
    'about',
    'services',
    'service',
    'events',
    'event',
    'series',
    'invite',
    'waitlists',
    'checkout',
    'booked',
    'pay',
    'bookings',
    'booking',
    'complete',
    'profile',
    'form-request',
  ],
  siteRoutes: {
    prefix: '/api/site',
    routes: [
      { method: 'POST', url: '/api/site/sign-in/start' },
      { method: 'POST', url: '/api/site/sign-in' },
      { method: 'POST', url: '/api/site/dev-sign-in', devOnly: true },
      { method: 'GET', url: '/api/site/session' },
      { method: 'POST', url: '/api/site/sign-out' },
      { method: 'GET', url: '/api/site/studio' },
      { method: 'GET', url: '/api/site/theme.css' },
      { method: 'GET', url: '/api/site/services/popular' },
      { method: 'GET', url: '/api/site/happening-soon' },
      { method: 'GET', url: '/api/site/offerings/soonest' },
      { method: 'GET', url: '/api/site/services/open-times' },
      ...catalog(''),
      ...catalog('/client'),
    ],
  },
  // session-own-link D6: a service's "On your website" setting (its link made from its name, "Only by this link").
  adminRoutes: {
    prefix: '/api/admin/services/*/site-link',
    routes: [
      { method: 'GET', url: '/api/admin/services/:id/site-link' },
      { method: 'PATCH', url: '/api/admin/services/:id/site-link' },
    ],
  },
  adminSections: [],
  noticeTypes: [],
  clientMessageTypes: [],
  emailKinds: [],
  services: [],
  siteOptions: {
    messageStudioLine: {
      kind: 'text',
      maxLength: 80,
      description: "The line under Message the studio's heading. {studio} stands for the studio's name, as in Message Dana at {studio}.",
      default: 'Message {studio}.',
    },
  },
});
